var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramInline = function SvgInstagramInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 20 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#instagramInline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.091 2.318H5.91A4.09 4.09 0 0 0 1.82 6.41v8.182a4.09 4.09 0 0 0 4.09 4.09h8.182a4.09 4.09 0 0 0 4.091-4.09V6.409a4.09 4.09 0 0 0-4.09-4.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.273 9.985a3.273 3.273 0 1 1-6.476.96 3.273 3.273 0 0 1 6.476-.96M14.905 5.94a.41.41 0 1 1-.81.12.41.41 0 0 1 .81-.12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagramInline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.182.682h19.636v19.636H.182z"
  })))));
};
export default SvgInstagramInline;